<template>
	<div>
        <v-container grid-list-md text-xs-center>
			<v-layout row wrap class="pl-4 pr-4 pt-4 pb-4">
				-- {{ userRoles[0] }} --
				<br /><br />			
				-- {{ roleId }} --
			</v-layout> 
		</v-container>	
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		data () {
			return {						
			}
		},
		computed: {
			...mapGetters([
				'roleId',
				'userRoles'
			])
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>